import { render, staticRenderFns } from "./GeneralReceiptDisplayView.vue?vue&type=template&id=650a3bba"
import script from "./GeneralReceiptDisplayView.vue?vue&type=script&lang=js"
export * from "./GeneralReceiptDisplayView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports